export default __webpack_public_path__ + "static/media/BB_17.8ccbc91c.png";